import RespectModalComponent from "../components/respect-modal-component";
import {removeHiddenClassBody} from "./remove-hidden-class-body";
import {remove, render, RenderPosition} from "./render";
import {setHiddenClassBody} from "./set-hidden-class-body";

let modalComponent = null;

const onEscPressModalHandler = (evt) => {
  if (evt.key === `Escape`) {
    removeModal();
  }
};

const removeModal = () => {
  if (modalComponent) {
    modalComponent.setHideClass();
  }
  removeHiddenClassBody();

  document.removeEventListener(`keydown`, onEscPressModalHandler);

  setTimeout(() => {
    remove(modalComponent);
    modalComponent = null;
  }, 1000);
};


export const showRespectModal = (message) => {
  modalComponent = new RespectModalComponent({message});
  render(document.querySelector(`body`), modalComponent.getElement(), RenderPosition.BEFOREEND);

  modalComponent.setCloseButtonClickHandler(() => removeModal());
  modalComponent.setOverlayClickHandler(() => removeModal());
  setHiddenClassBody();

  modalComponent.setShowClass();

  document.addEventListener(`keydown`, onEscPressModalHandler);

  setTimeout(() => {
    removeModal();
  }, 3000);
};
